//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';


//-================ IMPORTS FOR SERVICES ================-\\
import { LibraryFINService } from 'src/app/Services/Libraries/General-FIN/library-fin.service';


//-================ IMPORTS FOR CONSTANTS ================-\\


//-================ IMPORTS FOR DEPENDENCIES ================-\\
import moment from 'moment';
import Swal from 'sweetalert2';


//-================ IMPORTS FOR INTERFACES ================-\\
import { Data_Check } from 'src/app/Interfaces/Libraries/Library-FIN-int/Filter_Check_FIN.interface';
import { Headers_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Headers-CCP.interface';
import { Data_FIN_FLOWM } from 'src/app/Interfaces/Libraries/Library-FIN-int/Data_FIN_FlowM.interface';




@Component({
    selector: 'app-flow-monitoring-fin',
    templateUrl: './flow-monitoring-fin.component.html',
    styleUrls: ['./flow-monitoring-fin.component.scss', '../../../../Styles/GlobalStyles.css', '../../../../Styles/FlowMGlobal.css'],
    standalone: false
})
export class FlowMonitoringFINComponent implements OnInit {

  //+================== VARIABLES CREDENTIALS ==================+\\
  private ID_User_BD: number = 0;

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';

  //+================== SEARCH ==================+\\
  public Filter_FlowM: string = '';

  //+================== VARIABLES GLOBAL FILES FLOW M FIN ==================+\\
  public ALL_FLOWM_FIN: Data_FIN_FLOWM[] = [];
  public Copy_ALL_FLOWM_FIN: Data_FIN_FLOWM[] = [];
  public SelectedALL_FLOWM_FIN: Data_FIN_FLOWM[] = [];

  public LoadPage: boolean = false;
  public IsExpired: boolean = false;

  //+================== VARIABLES FOR HEADERS FM ==================+\\
  public HeadersFM: any[] = [];

  //+================== FOR FILTERS ==================+\\
  public Filter_Global_Check: any = {
    Extension: [],
    Status: [],
    Revision_No: [],
    Contributor_Name: [],
  };

  public GlobalFilterFields: string[] = ['Name', 'Code', 'Purpose'];


  //+================== VARIABLES FOR ICONS ==================+\\
  public Icons = [
    { Icon: 'fa-user-slash', Description: 'El usuario no fue requerido en el flujo' },
    { Icon: 'fa-user-pen', Description: 'El Proceso está siendo revisado' },
    { Icon: 'fa-user-clock', Description: 'El proceso está pendiente de pasar al siguiente nivel de aprobación' },
    { Icon: 'fa-user-check', Description: 'El Proceso ha sido revisado y aprobado' },
    { Icon: 'fa-user-xmark', Description: 'El Proceso ha sido revisado y rechazado' },
    { Icon: 'fa-user-shield', Description: 'El Proceso ha sido aprobado por un administrador' },
    { Icon: 'fa-user-shield', Description: 'El Proceso ha sido rechazado por un administrador' },
    { Icon: 'fa-users-slash', Description: 'No existe aprobador' },
    { Icon: 'fa-person-circle-question', Description: 'No Se tienen datos del aprobador, El Proceso puede ser muy antiguo' }
  ];


  //-========================= SERVICES =========================-\\

  private Service_FIN = inject(LibraryFINService);
  private router = inject(Router);

  constructor() {
    this.ID_User_BD = Number(localStorage.getItem('ID_U_DB'));
  }

  ngOnInit(): void {
    this.Load_Component();
  }

  //&===================== FUNCTION FOR LOAD COMPONENT FLOW MONITORING FIN =====================&\\

  private async Load_Component(): Promise<void> {

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    try {

      const resHeaders: any = await firstValueFrom(this.Service_FIN.Get_Headers('fin'));
      if (resHeaders.success) {
        // Filter to only include keys relevant for Flow Monitoring to avoid misalignment with unhandled columns
        const validKeys = ['NAMFI', 'CODEF', 'DESCR', 'NOREV', 'DACRE', 'DAEXP', 'STATU'];
        this.HeadersFM = resHeaders.operation.filter((h: any) => 
          h.Visible && (validKeys.includes(h.Key_Header) || h.Key_Header.startsWith('APPR'))
        );
        
        // Add dynamic approver names to global filter fields
        this.GlobalFilterFields = ['Name', 'Code', 'Purpose', 'Contributor_Name'];
        this.HeadersFM.forEach(h => {
          if (h.Key_Header.startsWith('APPR')) {
            this.GlobalFilterFields.push(`${h.Key_Header.replace('APPR', 'Approver')}_Name`);
          }
        });
        
        // Always include ROUTE at the beginning for parity with legacy FIN library UI
        this.HeadersFM.unshift({ ID: 0, Name: 'Ruta', Position: 0, Visible: true, Key_Header: 'ROUTE' });
      }

      const ResFlow_M_FIN: any = await firstValueFrom(this.Service_FIN.Get_FIN_Created_Rel_By_User({ ID_User: this.ID_User_BD }));

      if (ResFlow_M_FIN.success) {
        this.ALL_FLOWM_FIN = ResFlow_M_FIN.operation;
        this.Copy_ALL_FLOWM_FIN = ResFlow_M_FIN.operation;
      }

      this.LoadPage = true;
      Loader.classList.remove('active');

      this.Generate_Filters();

    } catch (e) {
      Swal.fire({
        title: 'Error',
        text: '¡Error al cargar estatus de Proceso, recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })

      Loader.classList.remove('active');
      this.LoadPage = true;

    }


  }

  //&===================== END FUNCTION FOR LOAD COMPONENT FLOW MONITORING FIN =====================&\\


  //&===================== FUNCTIONS FOR GENERAL FLOW MONITORING FIN =====================&\\

  //-================ FUNCTION FOR MODAL HELP ================-\\
  public ToggleModalHelp(CloseOrOpen: boolean): void {
    const ModalIconsHelp = document.getElementById('ModalIconsHelp') as HTMLDivElement;
    CloseOrOpen ? ModalIconsHelp.classList.add('active') : ModalIconsHelp.classList.remove('active');
  }

  //-================ FUNCTION FOR DATE FORMAT ================-\\
  public DateFormat(Date_Created: Date): string {
    return moment(Date_Created).utc().format('DD/MM/YYYY hh:mm:ss a')
  }

  //-================ FUNCTION FOR STATUS OF FIN ================-\\
  public Status_string(Status: number): string {
    switch (Status) {
      case 1: return 'Aprobado';
      case 2: return 'Pendiente';
      case 3: return 'Rechazado';
      case 4: return 'Eliminado';
      default: return '';
    }
  }

  //-================ FUNCTION FOR SEE FIN IN FIN LIBRARY FILE MANAGER ================-\\
  public SeeFINLibrary(URL: string): void {

    const RouteEncode: string = encodeURIComponent(URL);

    this.router.navigate([`Dashboard/FIN/FMLibraryFIN/${RouteEncode}`]);
  }

  //-================ FUNCTION GREETING ================-\\
  public GetGreeting(): string {

    let TextGTings: string = '';

    const Date_User = new Date();
    const Hour = Date_User.getHours();

    if (Hour >= 0 && Hour <= 5) {
      TextGTings = 'Buenas noches';
    } else if (Hour >= 6 && Hour <= 11) {
      TextGTings = 'Buenos días';
    } else if (Hour >= 12 && Hour <= 17) {
      TextGTings = 'Buenas tardes';
    } else if (Hour >= 18) {
      TextGTings = 'Buenas noches';
    }

    return TextGTings;
  }

  //-================ FUNCTION FOR NAME USER ================-\\
  public NameUser(): string {
    const Name_User: string = localStorage.getItem('Name_User') || '';
    return (Name_User.split(' ', 2)).join(' ');
  }

  //-================ FUNCTION FOR ASSIGNED STATUS IN FIN OF DATE EXPIRED ================-\\
  public Expiry_Status(Date_Expiration: Date): string {

    const Current_Date = moment().utc();

    const Date_Difference = moment(Date_Expiration, 'YYYY/MM/DD').utc();

    const Diference = Date_Difference.diff(Current_Date, 'days');

    if (Diference >= 90) {
      return 'NotExpired'
    } else if (Diference >= 0 && Diference <= 90) {
      return 'NearingExpired'
    } else if (Diference < 0) {
      return 'Expired'
    } else {
      return 'NotExpired'
    }
  }

  //-================== FUNCTION FOR CUT CODE ==================-\\
  public Cut_Code(Code: string): string {
    return Code.length > 15 ? Code.slice(0, 15) + '...' : Code;
  }

  //-================== FUNCTION FOR SEE CODE COMPLETE ==================-\\
  public See_Code(Code: string): void {
    Swal.fire({
      title: 'Código',
      text: Code,
      confirmButtonColor: this.ColorConfirm
    })
  }

  //-================ FUNCTION CUT DESCRIPTION ================-\\
  public Cut_Purpose(Purpose: string): string {
    return Purpose.length > 32 ? Purpose.slice(0, 32) + '...' : Purpose;
  }

  //-================ FUNCTION SEE DESCRIPTION COMPLETE ================-\\
  public See_Purpose(Purpose: string): void {
    Swal.fire({
      title: 'Objetivo del proceso',
      text: Purpose,
      confirmButtonColor: this.ColorConfirm
    })
  }

  public Get_Name_Approver(Name: string | null | undefined) {
    return Name === null ? 'No fue requerido' : Name;
  }

  public Get_Dynamic_Approver_Name(FlowItem: any, key: string): string {
    return FlowItem[`${key}_Name`] || 'No fue requerido';
  }

  public Get_Dynamic_Approver_Status(FlowItem: any, key: string): number {
    return FlowItem[`StatusTask${key.replace('APPR', '')}`] || 0;
  }

  //&===================== END FUNCTIONS FOR GENERAL FLOW MONITORING FIN =====================&\\




  //&===================== FUNCTION FOR FILTER DATE EXPIRED IN FIN =====================&\\

  public Filter_Date_Expired(): void {

    (this.IsExpired) ? (this.IsExpired = false) : (this.IsExpired = true)

    let Array_Filter: Data_FIN_FLOWM[] = [];

    for (let i = 0; i < this.ALL_FLOWM_FIN.length; i++) {

      const FINFM = this.ALL_FLOWM_FIN[i];

      let Current_Date = moment().utc();

      let Current_Date2 = moment(FINFM.Date_Expiration, 'YYYY/MM/DD').utc();

      let Date_Difference = moment(Current_Date2, 'YYYY/MM/DD').utc();

      let Diference = Date_Difference.diff(Current_Date, 'days');

      if (15 >= Diference) {
        Array_Filter.push(FINFM);
      }
    }

    (!this.IsExpired) ? (this.ALL_FLOWM_FIN = this.Copy_ALL_FLOWM_FIN) : (this.ALL_FLOWM_FIN = Array_Filter)

  }

  //&===================== END FUNCTION FOR FILTER DATE EXPIRED IN FIN =====================&\\





  //-===================== FUNCTION FOR FILTERS =====================-\\
  private Generate_Filters(): void {

    this.Filter_Global_Check = {
      Extension: [],
      Status: [],
      Revision_No: [],
      Contributor_Name: [],
    } as any;

    // Add dynamic approver arrays based on headers
    this.HeadersFM.forEach((h: any) => {
      if (h.Key_Header.startsWith('APPR')) {
        this.Filter_Global_Check[h.Key_Header] = [];
      }
    });

    for (const FIN of this.ALL_FLOWM_FIN as any) {

      FIN.Date_Created = moment(FIN.Date_Created).utc().toDate();
      FIN.Date_Expiration = (FIN.Date_Expiration && moment(FIN.Date_Expiration).isValid()) ? moment(FIN.Date_Expiration).utc().toDate() : null;

      FIN.F_Extension = { Value: FIN.Extension } as Data_Check;
      FIN.F_Status = { Value: FIN.Status } as Data_Check;
      FIN.F_Revision_No = { Value: FIN.Revision_No } as Data_Check;
      FIN.F_Contributor_Name = { Value: FIN.Contributor_Name } as Data_Check;

      if (!this.Filter_Global_Check.Extension.some((item: any) => item.Value === FIN.Extension) && FIN.Extension !== null) {
        this.Filter_Global_Check.Extension.push({ Value: FIN.Extension })
      }

      if (!this.Filter_Global_Check.Status.some((item: any) => item.Value === FIN.Status) && FIN.Status !== null) {
        this.Filter_Global_Check.Status.push({ Value: FIN.Status })
      }

      if (!this.Filter_Global_Check.Revision_No.some((item: any) => item.Value === FIN.Revision_No) && FIN.Revision_No !== null) {
        this.Filter_Global_Check.Revision_No.push({ Value: FIN.Revision_No })
      }

      if (!this.Filter_Global_Check.Contributor_Name.some((item: any) => item.Value === FIN.Contributor_Name) && FIN.Contributor_Name !== null) {
        this.Filter_Global_Check.Contributor_Name.push({ Value: FIN.Contributor_Name })
      }

      // Populate dynamic approver filters
      this.HeadersFM.forEach((h: any) => {
        if (h.Key_Header.startsWith('APPR')) {
          const name = this.Get_Dynamic_Approver_Name(FIN, h.Key_Header);
          if (name && name !== 'No fue requerido') {
            const filterArray = this.Filter_Global_Check[h.Key_Header] as any[];
            if (filterArray && !filterArray.some((item: any) => item.Value === name)) {
              filterArray.push({ Value: name });
            }
          }
        }
      });

    }


  }
  //-===================== END FUNCTION FOR FILTERS =====================-\\
}
